module.exports = __webpack_public_path__ + "img/logo_eng_20260401.0c00daad.gif";